import { getV2, postV2, patchV2, deletedV2 } from 'api/request'

// v2 Calendar Task collection — the same /core/calendar/task endpoint Lead Detail's
// Tasks tab and Issue Detail's Tasks tab already read/write. This module talks to it
// unscoped (no lead/issue target_objects on the base list) for a standalone task agenda.
//
// List query params (per v2/schema/core, re-checked 2026-09-23): target_objects,
// target_groups, user, owner, assigned_to, status, due_start, due_end, sort, offset, size.
// NO text search (no `q`, no `search`). `due_start`/`due_end` (plain dates) and `sort` are
// all new since the previous 2026-09-17 check, which had found no date-range or sort param
// at all — `sort` follows the same `field` / `-field` convention as LeadList's `sort`
// (e.g. `due_at` ascending, `-due_at` descending). `user` is a newer, broader "involves
// this user" filter (added server-side after `assigned_to` existed) — TaskPage's
// FilterBar uses it for a separate "User" field alongside the existing "Assignee"
// (`assigned_to`).
//
// v2 registers the bare collection path WITH a trailing slash; {uid} and sub-paths
// WITHOUT one.
export const API_TASK = '/core/calendar/task'

// filters: { status?, user?, assigned_to?, owner?, target_objects?, target_groups?,
// due_start?, due_end?, sort? } — `user` / `assigned_to` are comma-joined uid lists (same
// shape LeadList sends); `due_start`/`due_end` are 'YYYY-MM-DD' dates. target_groups is a
// comma-joined "type:uid" string scoped to a *group* record (e.g. "project/Project:456"
// — a whole project, not a single issue), matching a `target_group_type`/`target_group_uid`
// pair from `getTaskLinkGroups()` below.
export const getTaskList = (filters = {}, offset = 0, size = 200) => (
  getV2(`${API_TASK}/`, {
    urlParams: {
      status: filters.status || undefined,
      user: filters.user || undefined,
      assigned_to: filters.assigned_to || undefined,
      owner: filters.owner || undefined,
      target_objects: filters.target_objects || undefined,
      target_groups: filters.target_groups || undefined,
      due_start: filters.due_start || undefined,
      due_end: filters.due_end || undefined,
      sort: filters.sort || undefined,
      offset,
      size,
    },
  })
)

// Faceting endpoint — one row per distinct target *group* currently linked to at least
// one task, with a count. Not paginated (plain array). Powers the "Lead/Project Type"
// filter's option list — see `getEventLinkGroups()` in api/event.js for the mirrored
// Event-side version and fuller comment. Takes the same filter params as the list
// endpoint to scope the facet counts, but TaskPage calls it bare (unfiltered).
export const getTaskLinkGroups = () => getV2(`${API_TASK}/link-groups`)

export const getTask = (taskKey) => getV2(`${API_TASK}/${taskKey}`)

export const createTask = (data) => postV2(`${API_TASK}/`, data)

export const updateTask = (taskKey, data) => patchV2(`${API_TASK}/${taskKey}`, data)

export const deleteTask = (taskKey) => deletedV2(`${API_TASK}/${taskKey}`)

// Links: same dedicated sub-endpoints as events.
//   POST   /core/calendar/task/{uid}/link   LinkIn
//   PATCH  /core/calendar/task/link/{pk}    LinkUpdateIn
//   DELETE /core/calendar/task/link/{pk}
export const addTaskLink = (taskKey, link) => postV2(`${API_TASK}/${taskKey}/link`, link)

export const updateTaskLink = (linkPk, data) => patchV2(`${API_TASK}/link/${linkPk}`, data)

export const deleteTaskLink = (linkPk) => deletedV2(`${API_TASK}/link/${linkPk}`)
